export default __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240 copy-92bef7e45fed3caba8dc9348edef4df2.png";